import { initHeader } from './modules/header';
import { initHome } from './pages/home';

document.addEventListener('DOMContentLoaded', () => {
  initHeader();
  initHome();
});
